import { apiRequest } from './core';
import type { components } from '@/types/api.generated';

export type SystemAnnouncementForUser = components['schemas']['SystemAnnouncementForUserResponse'];
export type SystemAnnouncementsResponse = components['schemas']['SystemAnnouncementsForUserListResponse'];

export const systemAnnouncementsApi = {
  getAll: async (limit = 20, offset = 0, read?: string): Promise<SystemAnnouncementsResponse> => {
    let url = `/api/system-announcements?limit=${limit}&offset=${offset}`;
    if (read) url += `&read=${read}`;
    return apiRequest<SystemAnnouncementsResponse>(url);
  },

  markRead: async (id: string): Promise<{ success: boolean }> => {
    return apiRequest<{ success: boolean }>(`/api/system-announcements/${id}/read`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
    });
  },

  markAllRead: async (): Promise<{ success: boolean; data: { markedCount: number } }> => {
    return apiRequest<{ success: boolean; data: { markedCount: number } }>(
      '/api/system-announcements/mark-all-read',
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
      }
    );
  },
};
